// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwitcherFilledSvg from "@ant-design/icons-svg/es/asn/SwitcherFilled";
import AntdIcon from '../components/AntdIcon';

var SwitcherFilled = function SwitcherFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherFilledSvg
  }));
};

SwitcherFilled.displayName = 'SwitcherFilled';
export default React.forwardRef(SwitcherFilled);